import Macy from 'macy';
import AOS from 'aos';
import Swiper from 'swiper/dist/js/swiper.js';

export default {
  init() {
    /* MAIN MENU */
    //jQuery('header').css('height', '305px');
    jQuery('.nav-primary .nav > li.menu-item').on("mouseenter", function() {
      jQuery('.homepage-slider').css('top', '-20px');
    }).on("mouseleave", function() {
      jQuery('.homepage-slider').css('top', '-100px');
    });

    jQuery(".block-highlight-top").on('click wheel touchstart touchmove scroll', function (event) {
      highlightMove(event);
    });

    jQuery(".block-highlight-top").find('.arrow-down').on('click', function (event) {
      highlightMove(event);
    });

    function highlightMove(event) {
      if(event != false) { event.preventDefault(); }
      jQuery('.block-highlight-top').slideUp(700);
      jQuery('body').addClass('toggleHighlight');
      setTimeout(function() {
        AOS.refresh();
        var HomeSlider = new Swiper('.homepage-main-slider', {
          autoplay: {
            delay: 8000,
            disableOnInteraction: false,
          },
          speed: 600,
          effect: 'fade',
          centeredSlides: true,
          loop: true,
          slidesPerView: 1,
          preloadImages: true,
          updateOnImagesReady: true,
          //setWrapperSize: true,
          spaceBetween: 50,
          navigation: {
            nextEl: '.homepage-slider-next',
            prevEl: '.homepage-slider-prev',
          },
          on: {
            resize: function () {
              this.update();
            },
          },
        });
        jQuery(window).on('orientationchange', function() {
          setTimeout(function() {
            HomeSlider.update();
          }, 1500);
        });
      }, 1200);
    }

    jQuery(document).ready(function() {
      if (jQuery(document).scrollTop() > 0) {
        highlightMove(false);
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    Macy({
      container: '.featured-products',
      trueOrder: false,
      waitForImages: true,
      margin: 24,
      columns: 2,
      breakAt: {
        577: {
          margin: {
            x: 24,
            y: 50,
          },
          columns: 2,
        },
        576: {
          margin: {
            x: 24,
            y: 20,
          },
          columns: 1,
        },
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js